import { jsx as o } from "react/jsx-runtime";
import { forwardRef as n } from "react";
import i from "../Box/Box.js";
import "styled-components";
const l = n((t, e) => {
  const { children: r } = t;
  return /* @__PURE__ */ o(
    i,
    {
      ref: e,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      height: "100%",
      width: "100%",
      children: r
    }
  );
});
export {
  l as default
};
